import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import axios from "axios";
import { Link } from "react-router-dom";
import { useHistory, useParams } from "react-router-dom";
import { endpoints } from "../../../services/apiurl";
import { Card, Grid, FormControl, Button } from "@mui/material";
import PageTitle from "../../UI/PageTitle";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { InfinitySpin } from "react-loader-spinner";

const MediaDetail = () => {
  let history = useHistory();
  let { restro_id } = useParams();
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [items, setItems] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [type, setType] = useState("");
  const [rest, setRest] = useState([]);
  const [user_id, setuser_id] = useState("");
  const [roll_restro_id, set_roll_restro_id] = useState("");
  const [selectedRestroId, setSelectedRestroId] = useState("");

  useEffect(() => {
    getRestaurentsDropDown();
    fetchData(1, perPage);
  }, [perPage]);

  const columns = [
    {
      name: "RESTAURANTS NAME",
      selector: (row) => row.restName,
    },
    {
      name: "MEDIA TYPE",
      selector: (row) =>
        row.media_type == 1 ? (
          <img
            src={`${row.media}`}
            style={{ height: "150px", width: "150px", margin: "10px" }}
          ></img>
        ) : (
          "Video"
        ),
    },
    {
      name: "TYPE",
      selector: (row) => row.type,
    },
    {
      name: "ACTION",
      cell: (row) => (
        <div>
          {" "}
          <Link to={`/dashboard/editmedia/${row.id}`}>
            {" "}
            <EditIcon />{" "}
          </Link>
          <Link
            className="error"
            style={{ marginTop: "7px", marginLeft: "10px" }}
            onClick={() => {
              confirmAlert({
                title: "Confirm",
                message: "Do you really want to delete?",
                buttons: [
                  {
                    label: "Yes",
                    onClick: () => removeContactHandler(row.id),
                  },
                  {
                    label: "No",
                    onClick: () => {},
                  },
                ],
              });
            }}
          >
            <DeleteIcon />
          </Link>
        </div>
      ),
      selector: (row) => row.id,
    },
  ];

  const removeContactHandler = async (id) => {
    await axios
      .post(endpoints.deleteRestaurentsMedia, { id })
      .then((response) => {});
    const newContactList = items.filter((contact) => {
      return contact.id !== id;
    });
    setItems(newContactList);
  };

  const getRestaurentsDropDown = async () => {
    await axios.post(endpoints.getRestaurentsDropDown).then((response) => {
      setRest(response.data.data);
    });
  };

  const fetchData = async (page, per_page) => {
    try {
      let user = localStorage.getItem("user");
      let userData = JSON.parse(user);
      let user_id = userData.id;
      let restro_id = userData.restro_id;
      set_roll_restro_id(userData.restro_id);

      const response = await axios.post(endpoints.getRestaurentsMedia, {
        page,
        per_page,
        user_id,
        restro_id,
      });

      setIsLoaded(true);
      setItems(response.data.data);
      setTotalRows(response.data.total);
      setSelectedRestroId(restro_id);
    } catch (error) {
      setIsLoaded(true);
      setError(error);
    }
  };

  const handleSearch = async (page, per_page, user_id, type, restro_id) => {
    try {
      const response = await axios.post(endpoints.filterRestaurentsMedia, {
        page,
        per_page,
        user_id,
        type,
        restro_id,
      });
      setIsLoaded(true);
      setItems(response.data.data);
      setTotalRows(response.data.total);
    } catch (error) {
      setIsLoaded(true);
      setError(error);
      console.error("Error filtering restaurants:", error);
    }
  };

  const onInputChange = (event) => {
    const selectedId = event.target.value;
    setSelectedRestroId(selectedId);
    handleSearch(1, perPage, user_id, type, selectedId);
  };

  const onTypeChange = (event) => {
    const selectedType = event.target.value;
    setType(selectedType);
    handleSearch(1, perPage, user_id, selectedType, selectedRestroId);
  };

  const handlePageChange = (page) => {
    handleSearch(page, 10, user_id, type, selectedRestroId);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    handleSearch(page, newPerPage, user_id, type, selectedRestroId);
  };

  const handleResetFilters = async () => {
    setType("");
    setSelectedRestroId("");
    await fetchData(1, 10, "", "");
  };

  if (error) {
    return <div>Error: {error.message}</div>;
  } else if (!isLoaded) {
    return (
      <div className="spinner">
        <InfinitySpin
          visible={true}
          width="200"
          color="#fbaa1a"
          ariaLabel="infinity-spin-loading"
        />
      </div>
    );
  } else {
    return (
      <div className="App">
        <PageTitle
          title="Gallery List"
          linkid={restro_id}
          linkurl="/dashboard/addmedia"
          linkTitle="Add Gallery"
        />

        <Card className="mt-3">
          <DataTable
            columns={columns}
            data={items}
            pagination
            paginationServer
            subHeader
            subHeaderComponent={
              <Grid
                container
                spacing={2}
                justifyContent="left"
                alignItems="center"
                style={{ padding: "10px" }}
              >

    {roll_restro_id === 0 ? (
      <Grid item xs={12} md={2} textAlign="center">
      <FormControl fullWidth>
        <select
          name="restro_id"
          required
          className="form-control"
          onChange={onInputChange}
          value={selectedRestroId}
          style={{cursor:"pointer"}}
        >
          <option value="">Select Restaurant</option>
          {rest.map((e) => (
            <option key={e.id} value={e.id}>
              {e.name}
            </option>
          ))}
        </select>
      </FormControl>
    </Grid>
    ):("")}

                

                <Grid item xs={12} md={2} textAlign="center">
                  <FormControl fullWidth>
                    <select
                      name="type"
                      value={type}
                      onChange={onTypeChange}
                      required
                      className="form-control"
                      style={{ fontSize: "14px",cursor:"pointer" }}
                    >
                      <option value="">Media Type</option>
                      <option value="food">Food</option>
                      <option value="drink">Drink</option>
                      <option value="ambiance">Ambience</option>
                    </select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={2} textAlign="center">
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleResetFilters}
                  >
                    Reset Filters
                  </Button>
                </Grid>
              </Grid>
            }
            paginationTotalRows={totalRows}
            onChangePage={handlePageChange}
            onChangeRowsPerPage={handlePerRowsChange}
          />
        </Card>
      </div>
    );
  }
};

export default MediaDetail;
